export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14796.13d1c2c5.jpg";